<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div id="we" class="steps">
    <h2>Всё включено:</h2>
    <div class="steps__content">
      <Step>
        <template v-slot:number>1</template>
        <template v-slot:title>Профессиональная техника и химия</template>
        <template v-slot:description>
          Мы используем только профессиональное оборудование Kärcher для химчистки.<br><br>
          Моющие компрессорные пылесосы Kärcher и только сертифицированная химия известных брендов
          для бережной химчистки любых покрытий.
        </template>
        <template v-slot:image>
          <img src="../assets/steps/1.jpg" alt="Профессиональная техника и химия">
        </template>
      </Step>
      <Step>
        <template v-slot:number>2</template>
        <template v-slot:title>Выезд по побережью Черногории</template>
        <template v-slot:description>
          <table class="steps__table">
            <tr>
              <td>Будва</td>
              <td>€0</td>
            </tr>
            <tr>
              <td>Тиват, Котор, Петровац</td>
              <td>€5</td>
            </tr>
            <tr>
              <td>Бар</td>
              <td>€10</td>
            </tr>
            <tr>
              <td>Подгорица</td>
              <td>€17</td>
            </tr>
            <tr>
              <td>Херцег-Нови</td>
              <td>€20</td>
            </tr>
          </table>
        </template>
        <template v-slot:image>
          <img src="../assets/steps/2.jpg" alt="Выезд по побережью Черногории">
        </template>
      </Step>
      <Step>
        <template v-slot:number>3</template>
        <template v-slot:title>Отличный результат</template>
        <template v-slot:description>
          Мы стараемся превзойти Ваши ожидания и добиться максимального эффекта в химчистке, чтобы Вы
          остались довольны нашей работой.
        </template>
        <template v-slot:image>
          <img src="../assets/steps/3.jpg" alt="Отличный результат">
        </template>
      </Step>
    </div>
  </div>
</template>

<script>
import Step from './Step';

export default {
  name: 'steps',
  components: {
    Step
  }
}
</script>

<style lang="scss" scoped>
@import '../assets/vars';

.steps {
  border-top: 1px solid $color-border;
  padding: 0 80px 80px;

  &__content {
    max-width: 1440px;
    margin: 0 auto;
  }

  &__table {
    border-collapse: collapse;
    margin-top: 20px;

    td {
      border: 1px solid #eee;
      padding: 8px 20px;
    }
  }

  &__link {
    transition: all 150ms ease-out;

    &:hover {
      background: $color-primary;
      color: white;
    }
  }
}

/* Landscape phones and portrait tablets */
@media (max-width: 767px) {
  .steps {
    padding: 0 20px 80px;
  }
}
</style>
